/**
 * @fileoverview POST handler for the "/:app_group_id/knowledge_source/definition/:id/refresh" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { knowledgeSourceDefinitionIdCacheKeys } from "./constants";
import type {
  KnowledgeSourceDefinitionIdResult,
  RefreshKnowledgeSourceDefinitionIdErrors,
  RefreshKnowledgeSourceDefinitionIdProps,
} from "./types";

export const postKnowledgeSourceDefinitionIdRefresh = reactQueryMutationAdapter(
  knowledgeSourceDefinitionIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<RefreshKnowledgeSourceDefinitionIdErrors>()(
    (props: RefreshKnowledgeSourceDefinitionIdProps): Promise<KnowledgeSourceDefinitionIdResult> => {
      return fetch(
        `/${props.appGroupId}/knowledge_source/definition/${props.definitionId}/refresh`,
        "POST",
        {},
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
